<script lang="ts">
import { cn } from "$lib/utils";

interface Props {
  class?: string;
  size?: string | number;
  strokeWidth?: number;
}

const { class: className, size = "11px", strokeWidth = 2 }: Props = $props();

const sizeStyle = $derived(typeof size === "number" ? `${size}rem` : size);
</script>

<div
  class={cn("bg-primary rounded-sm border-primary z-10 shadow", className)}
  style="width: {sizeStyle}; height: {sizeStyle}; border-width: {strokeWidth}px;"
></div>
